import CardSituation from '../../../components/Card/Situation';
import { RoutePaths } from '../../../config/routes';
import Heading from '../../../components/Typography/Heading';
import Button from '../../../components/Button';
import { ChevronLeft } from 'react-feather';
import StepWrapper from '../../../components/Step/Wrapper';
import FormLayout from '../../../components/Step/FormLayout';
import ReassuranceWrapper from '../../../components/Reassurance/Wrapper';
import Paragraph from '../../../components/Typography/Paragraph';
import ReassuranceItem from '../../../components/Reassurance/Item';
import { Handshake, Sparkle, Shape1, Pro, Eye } from '../../../components/CustomIcon';
import FormGrid from '../../../components/Step/FormGrid';
import FormCol from '../../../components/Step/FormCol';
import { useLocation } from 'react-router-dom';
import FadeUp from '../../../components/Animation/FadeUp';
import { AnimatePresence, motion } from 'framer-motion';
import Seo from '../../../components/Seo';
var shapeVariant = {
    hidden: {
        scale: 0,
        rotate: -180,
    },
    visible: {
        scale: 1,
        rotate: 0,
        transition: {
            ease: 'easeOut',
            duration: 0.25,
            delay: 0.2,
        },
    },
    exit: {
        scale: 0,
        rotate: -180,
    },
};
var SignInSituation = function () {
    var pathname = useLocation().pathname;
    var cards = [
        {
            title: 'Professionnel·le',
            description: 'Je m’identifie comme une femme, une personne trans ou non-binaire professionnel·le de l’industrie musicale.',
            to: RoutePaths.SIGN_UP_PROFESSIONAL,
            from: pathname,
            icon: Pro,
        },
        {
            title: 'Visiteur·se',
            description: 'Je veux accéder aux coordonnées des personnes référencées pour collaborer ou interagir avec elles.',
            to: RoutePaths.SIGN_UP_VISITOR,
            from: pathname,
            icon: Eye,
        },
    ];
    return (<>
      <Seo title="Indiquez votre situation"/>
      <StepWrapper>
        <FormLayout>
          <div className="relative h-full w-full overflow-hidden">
            <AnimatePresence>
              <motion.div className="absolute -bottom-[34rem] -left-[18rem] h-[765px] w-[765px] lg:-bottom-[40rem] lg:-left-[18rem] lg:h-[865px] lg:w-[865px]" variants={shapeVariant} initial="hidden" animate="visible" exit="exit">
                <Shape1 size={865} className="h-auto w-full"/>
              </motion.div>
            </AnimatePresence>
            <FormGrid className="relative mb-10 lg:mb-20">
              <div className="mb-8 pt-10 lg:col-span-12">
                <Button type="inline" icon={ChevronLeft} side="start" className="flex-1 text-gray-500" to={RoutePaths.SIGN_IN}>
                  Précédent
                </Button>
              </div>
              <FormCol>
                <Heading level={1} type="h4">
                  Quelle est votre situation&nbsp;?
                </Heading>
                <div className="mt-6 flex flex-col gap-6">
                  {cards.map(function (card) { return (<CardSituation key={card.title} {...card}/>); })}
                </div>
              </FormCol>
            </FormGrid>
          </div>
        </FormLayout>
        <ReassuranceWrapper>
          <FadeUp>
            <Paragraph size="lg" className="lg:mb-4 2xl:mb-8">
              L’annuaire des professionnel·les femmes, personnes trans et non-binaires de la musique
            </Paragraph>
          </FadeUp>
          <ReassuranceItem icon={Handshake}>
            <Heading level={6}>Rejoignez la communauté</Heading>
            <Paragraph size="sm" className="mt-2">
              Complétez votre profil pour{' '}
              <span className="font-bold">être référencé·e sur Majeur·e·s.</span> Que votre carrière débute ou non, vous êtes déjà au coeur de l'industrie&nbsp;!
            </Paragraph>
          </ReassuranceItem>
          <ReassuranceItem icon={Sparkle} className="mt-10">
            <Heading level={6}>Trouvez des profils inspirants</Heading>
            <Paragraph size="sm" className="mt-2">
              Connectez-vous pour{' '}
              <span className="font-bold">accéder aux informations de contact</span> de nombreux·ses
              professionnel·le·s de l’industrie musicale.
            </Paragraph>
          </ReassuranceItem>
        </ReassuranceWrapper>
      </StepWrapper>
    </>);
};
export default SignInSituation;
